import React from 'react'
import GoogleIcon from '../../../../components/icon/GoogleIcon'
import {
  SPECIAL_PRICE_CREATE_ARIA_LABELS,
  SPECIAL_PRICE_CREATE_FIELD_LABELS,
  SPECIAL_PRICE_CREATE_STEP_CONTENT
} from '../specialPriceCreateConstants'

const SpecialPriceDatesStep = ({
  endDate,
  endDateInputRef,
  fieldErrors,
  onEndDateChange,
  onOpenNativeDatePicker,
  onStartDateChange,
  selectedProduct,
  startDate,
  startDateInputRef,
  todayISO
}) => {
  return (
    <div className="task-form-section">
      <div className="title-promos-form">
        <b>{SPECIAL_PRICE_CREATE_STEP_CONTENT.dates.title}</b>
      </div>
      <p>{SPECIAL_PRICE_CREATE_STEP_CONTENT.dates.description}</p>
      <hr className="hr-task-form" />

      <div className="special-price-dates-row">
        <div className="special-price-date-field">
          <p className="special-price-date-label">{SPECIAL_PRICE_CREATE_FIELD_LABELS.startDate}</p>
          <div className="special-price-date-input-wrapper">
            <button
              type="button"
              className="special-price-date-icon-button"
              onClick={() => onOpenNativeDatePicker(startDateInputRef)}
              disabled={!selectedProduct}
              aria-label={SPECIAL_PRICE_CREATE_ARIA_LABELS.startDate}
            >
              <GoogleIcon name="event" className="special-price-date-icon" />
            </button>
            <input
              ref={startDateInputRef}
              type="date"
              className={`special-price-date-input ${startDate ? 'special-price-date-input--filled' : ''} ${selectedProduct && fieldErrors.start_date ? 'is-invalid' : ''}`}
              min={todayISO}
              value={startDate}
              onChange={onStartDateChange}
              disabled={!selectedProduct}
            />
          </div>
          {selectedProduct && fieldErrors.start_date && (
            <div className="invalid-feedback d-block">{fieldErrors.start_date}</div>
          )}
        </div>

        <div className="special-price-date-separator" />

        <div className="special-price-date-field">
          <p className="special-price-date-label">{SPECIAL_PRICE_CREATE_FIELD_LABELS.endDate}</p>
          <div className="special-price-date-input-wrapper">
            <button
              type="button"
              className="special-price-date-icon-button"
              onClick={() => onOpenNativeDatePicker(endDateInputRef)}
              disabled={!selectedProduct}
              aria-label={SPECIAL_PRICE_CREATE_ARIA_LABELS.endDate}
            >
              <GoogleIcon name="event" className="special-price-date-icon" />
            </button>
            <input
              ref={endDateInputRef}
              type="date"
              className={`special-price-date-input ${endDate ? 'special-price-date-input--filled' : ''} ${selectedProduct && fieldErrors.end_date ? 'is-invalid' : ''}`}
              min={startDate || todayISO}
              value={endDate}
              onChange={onEndDateChange}
              disabled={!selectedProduct}
            />
          </div>
          {selectedProduct && fieldErrors.end_date && (
            <div className="invalid-feedback d-block">{fieldErrors.end_date}</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SpecialPriceDatesStep
